module.exports = __webpack_public_path__ + "img/ring-lvl3@2x.8083de7c.jpg";